<!-- 商品管理 V2 - 图片预览弹窗（列表展开区「查看全部」） -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    custom-class="product-image-preview-dialog"
  >
    <!-- 图片网格，支持 el-image 大图预览 -->
    <div class="preview-list">
      <el-image
        v-for="(image, index) in images"
        :key="image.id || index"
        :src="image.url"
        fit="cover"
        :preview-src-list="images.map(image => image.url)"
      />
    </div>
  </el-dialog>
</template>

<script>
/**
 * 通用图片预览弹窗
 * 供 productTable 实物图/包装图「查看全部」使用
 */
export default {
  name: 'ImagePreviewDialog',
  data() {
    return {
      visible: false,
      title: '', // 弹窗标题（实物图/包装图）
      images: [] // 图片列表 { id, url }
    }
  },
  methods: {
    // 打开预览弹窗
    open(title, images) {
      this.title = title
      this.images = images
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-list {
  display: grid;
  grid-template-columns: repeat(5, 112px);
  gap: 16px;
  min-height: 112px;
}
.preview-list .el-image {
  width: 112px;
  height: 112px;
  border-radius: 6px;
  cursor: zoom-in;
}
</style>

<style lang="scss">
.product-image-preview-dialog .el-dialog__body { padding-top: 12px; }
</style>
